<div class="flex h-full flex-col dark:bg-zinc-900">
  <app-navbar *ngIf="isAuthenticated"></app-navbar>
  <!-- Sidebar -->
  <div class="grow dark:bg-zinc-900" [class.flex]="isAuthenticated">
    <div *ngIf="sideOpen">
      <app-sidebar *ngIf="isAuthenticated && !preSurveyState"></app-sidebar>
    </div>
    <div id="inner-content" class="w-full">
      <router-outlet></router-outlet>
    </div>
  </div>
  <footer></footer>
</div>